/* eslint-disable no-eval */
import BuscarDadosCobrancaDTO from '../dtos/BuscarDadosCobrancaDTO';
import BuscarDadosPagamentoAnuidadeResultDTO from '../dtos/BuscarDadosPagamentoAnuidadeResultDTO';
import ResultCarregaDebito from '../dtos/cobol/ResultCarregaDebito';
import ResultGerarCobranca from '../dtos/cobol/ResultGerarCobranca';
import ResultMontarCobranca from '../dtos/cobol/ResultMontarCobranca';
import ResultPreparaBoleto from '../dtos/cobol/ResultPreparaBoleto';
import ResultPreparaCartao from '../dtos/cobol/ResultPreparaCartao';
import ResultTiposDebitos from '../dtos/cobol/ResultTiposDebitos';
import DadosInscritoDTO from '../dtos/DadosInscritoDTO';
import GerarBoletoDTO from '../dtos/GerarBoletoDTO';
import GerarBoletosZipResultDTO from '../dtos/GerarBoletosZipResultDTO';
import GerarCobrancaDTO from '../dtos/GerarCobrancaDTO';
import PrepararBoletoDTO from '../dtos/PrepararBoletoDTO';
import api from './api';

interface BuscarDadosPagamentoAnuidadeProps {
  numeroInscricao: number;
  cpf: string;
  numeroSeguranca: number;
  anuidade: number;
}

function convertResult<T>(value: any): T {
  if (typeof value === 'string') {
    let result: any = '';
    result = null;
    eval(`result = ${value}`);
    return result as T;
  }
  return value as T;
}

export default {
  validarAcessoToken: async (
    token: string,
    anuidade: number,
  ): Promise<DadosInscritoDTO> => {
    const { data } = await api.post<DadosInscritoDTO>('acesso/validarAcesso', {
      token,
      anuidade,
    });
    return data;
  },
  buscarDadosPagamentoAnuidade: async ({
    numeroInscricao,
    anuidade,
    cpf,
    numeroSeguranca,
  }: BuscarDadosPagamentoAnuidadeProps): Promise<BuscarDadosPagamentoAnuidadeResultDTO> => {
    const { data } = await api.post<BuscarDadosPagamentoAnuidadeResultDTO>(
      'acesso/buscarDadosPagamentoAnuidade',
      {
        numeroInscricao,
        cpf,
        numeroSeguranca,
        anuidade,
      },
    );
    return data;
  },
  buscarPagamentosRealizados: async ({
    numeroInscricao,
    anuidade,
    cpf,
    numeroSeguranca,
  }: BuscarDadosPagamentoAnuidadeProps): Promise<BuscarDadosPagamentoAnuidadeResultDTO> => {
    const { data } = await api.post<BuscarDadosPagamentoAnuidadeResultDTO>(
      'anuidade/buscarDadosPagamentoAnuidade',
      {
        numeroInscricao,
        cpf,
        numeroSeguranca,
        anuidade,
      },
    );
    return data;
  },
  tiposDebitos: async (ficha: number): Promise<ResultTiposDebitos> => {
    const { data } = await api.get<string>(`anuidade/${ficha}/tiposDebitos`);
    return convertResult<ResultTiposDebitos>(data);
  },
  carregaDebito: async (
    ficha: number,
    codigoTipoDebito: number,
    pesquisarComoTratarUniao: string,
  ): Promise<ResultCarregaDebito> => {
    const { data } = await api.get<string>(
      `anuidade/${ficha}/carregaDebito/${codigoTipoDebito}/${pesquisarComoTratarUniao}`,
    );
    return convertResult<ResultCarregaDebito>(data);
  },
  montarCobranca: async (
    dadosCobranca: BuscarDadosCobrancaDTO,
  ): Promise<ResultMontarCobranca> => {
    const { data } = await api.post<string>(
      `anuidade/${dadosCobranca.numeroFicha}/montarCobranca`,
      dadosCobranca,
    );
    return convertResult<ResultMontarCobranca>(data);
  },
  gerarCobranca: async (
    gerarCobranca: GerarCobrancaDTO,
  ): Promise<ResultGerarCobranca> => {
    const { data } = await api.post<string>(
      `anuidade/${gerarCobranca.numeroFicha}/gerarCobranca`,
      gerarCobranca,
    );
    return convertResult<ResultGerarCobranca>(data);
  },

  prepararBoleto: async (
    numeroFicha: number,
    prepararBoleto: PrepararBoletoDTO,
  ): Promise<ResultPreparaBoleto> => {
    const { data } = await api.post<string>(
      `anuidade/${numeroFicha}/prepararBoleto`,
      prepararBoleto,
    );
    return convertResult<ResultPreparaBoleto>(data);
  },
  prepararCartao: async (
    numeroFicha: number,
    numeroCobranca: number,
  ): Promise<ResultPreparaCartao> => {
    const { data } = await api.post<ResultPreparaCartao>(
      `anuidade/${numeroFicha}/prepararCartao`,
      { numeroCobranca },
    );
    return data;
  },

  gerarBoleto: async (
    numeroFicha: number,
    gerarBoleto: GerarBoletoDTO,
  ): Promise<void> => {
    await api.post(`anuidade/${numeroFicha}/gerarBoleto`, gerarBoleto);
  },

  gerarBoletosZip: async (
    numeroFicha: number,
    boletos: GerarBoletoDTO[],
  ): Promise<GerarBoletosZipResultDTO> => {
    const { data } = await api.post<GerarBoletosZipResultDTO>(
      `anuidade/${numeroFicha}/gerarBoletosZip`,
      { boletos },
    );
    return data;
  },
  enviarBoletosEmail: async (
    numeroFicha: number,
    sendEmail: string,
    boletos: GerarBoletoDTO[],
  ): Promise<void> => {
    await api.post(`anuidade/${numeroFicha}/enviarBoletosEmail`, {
      sendEmail,
      boletos,
    });
  },
};
